document.addEventListener('DOMContentLoaded', function () {
  const _b2bCheckoutLog = typeof window.createLogger === 'function'
    ? window.createLogger('B2BCheckoutValidator')
    : { log: () => {}, warn: () => {}, error: () => {} };
  const _vatPriceLog = typeof window.createLogger === 'function'
    ? window.createLogger('VAT Price Format')
    : { log: () => {}, warn: () => {}, error: () => {} };

  _b2bCheckoutLog.log('Initialized');
  const cartForm = document.getElementById('cart');
  if (!cartForm) return;
  _b2bCheckoutLog.log('Cart form found, setting up validator');
  let processing = false;
  let isB2BCustomerForCheckout = false;
  // Listen for B2B customer creation with VAT event
  window.addEventListener('B2B-customer-VAT-exemption-checked', (event) => {
    try {
      isB2BCustomerForCheckout = event.detail.isB2BCustomer || false;
      _b2bCheckoutLog.log('B2B customer created with VAT:', isB2BCustomerForCheckout);
    } catch (err) {
      _b2bCheckoutLog.warn('B2B customer creation event error:', err);
    }
  });
  cartForm.addEventListener('submit', async function (e) {
    e.preventDefault(); // 🔴 STOP immediately

    if (processing) return;
    processing = true;

    // Allow normal checkout if not B2B
    if (!isB2BCustomerForCheckout) {
      _b2bCheckoutLog.log('Not B2B → allow default checkout');
      await continueDefaultCheckout(e);
      return;
    }

    const countryCodeCheckout = window.getSelectedMarketCountry() || window.Shopify?.country || 'GB';

    const isEuCountryCheckout = window.is_EuCountry(countryCodeCheckout);

    if (!isEuCountryCheckout) {
      _b2bCheckoutLog.log('Non-EU → allow default checkout');
      await continueDefaultCheckout(e);
      return;
    }
    const { email, vat } = getVATandEmailFromForm();
    if (!email || email.length == 0 || !vat || vat.length == 0) {
      _b2bCheckoutLog.log('VAT form fields does not found → allow default checkout');
      await continueDefaultCheckout(e);
      return;
    }

    const countryNameCheckout = window.country_NameByCode(countryCodeCheckout);

    // Open the new tab NOW while still inside the user-gesture context,
    // before any await calls (browsers block window.open after async gaps)

    const fetchedCartDataCheckout = await window.CartUtils.fetchCart();
    _b2bCheckoutLog.log('Fresh cart data from fetchCart():', JSON.stringify(fetchedCartDataCheckout, null, 2));

    if (!fetchedCartDataCheckout || !fetchedCartDataCheckout.items || fetchedCartDataCheckout.items.length === 0) {
      processing = false;
      return;
    }
    const exchangeRate = Shopify.currency.rate;
    const lineItems = fetchedCartDataCheckout.items.map((it) => {
      var priceWithVat = it.price;
      var vatAmount = 0;
      // if (typeof window.getPriceWithoutVat === 'function') {
      //   priceWithoutVat = window.getPriceWithoutVat(it.price, countryCodeCheckout);
      //   _vatPriceLog.log('Using getPriceWithoutVat: on checkout validator ', priceWithoutVat);
      // } else {
      //   _vatPriceLog.log(
      //     'Using fallback price calculation: on checkout validator, missing getPriceWithoutVat() utility'
      //   );
      // }
      if (typeof window.getVatAmount === 'function') {
        vatAmount = window.getVatAmount(it.price, countryCodeCheckout);
        _vatPriceLog.log('Using getVatAmount: on checkout validator ', vatAmount);
      } else {
        _vatPriceLog.log('Using fallback price calculation: on checkout validator, missing getVatAmount() utility');
      }
      // const priceInShopCurrency = (priceWithoutVat / 100 / exchangeRate).toFixed(2);
      const lineItem = {
        title: it.title || it.product_title || '',
        quantity: it.quantity,
        price: (priceWithVat / 100 / exchangeRate).toFixed(2),
        requires_shipping: it.requires_shipping,
        sku: it.sku || ''
      };

      // Only add applied_discount if discounts array exists and has items
      const VATInShopCurrency = (Math.round(vatAmount / exchangeRate) / 100).toFixed(2);
      if (vatAmount > 0) {
        lineItem.applied_discount = {
          title: `Excluding ${countryNameCheckout} VAT`,
          description: 'VAT Exemption applied via B2B form',
          value: VATInShopCurrency,
          value_type: 'fixed_amount'
        };
      }

      // Only add applied_discount if discounts array exists and has items
      // if (Array.isArray(it.discounts) && it.discounts.length > 0) {
      //   lineItem.applied_discount = {
      //     title: it.discounts[0].title || '',
      //     description: it.discounts[0].title || '',
      //     value: (it.discounts[0].amount / 100).toFixed(2),
      //     value_type: 'fixed_amount'
      //   };
      // }

      return lineItem;
    });

    const shippingAddress = {
      country: countryNameCheckout
    };

    const shippingLine = {
      title: 'B2B Standard Shipping (DAP)',
      price: '16.00',
      custom: true
    };

    try {
      if (window.B2BVatExemptionForm && typeof window.B2BVatExemptionForm.handleSubmit === 'function') {
        const submitResult = await window.B2BVatExemptionForm.handleSubmit();
        if (!submitResult || !submitResult.success) {
          _b2bCheckoutLog.warn('B2B form submit failed, skipping draft order', submitResult);
          const message =
            (submitResult && submitResult.response && submitResult.response.message) ||
            'Please check your B2B VAT details and try again.';
          if (window.N4YToast && typeof window.N4YToast.show === 'function') {
            window.N4YToast.show(message, { type: 'error', id: 'b2b-checkout-toast' });
          } else {
            alert(message);
          }
          processing = false;
          return;
        }
      }

      const response = await window.externalApiClient.createDraftOrder(email, vat, lineItems, shippingAddress);

      _b2bCheckoutLog.log('Draft order created:', response);

      if (response.status && response.message === 'Success') {
        const checkoutUrl = response.data.invoice_url;
        _b2bCheckoutLog.log('Redirecting to checkout URL:', checkoutUrl);
        // ✅ Navigate the pre-opened tab to the draft order invoice URL
        // ✅ Open checkout URL in a new tab (anchor click bypasses popup blockers)
        // const a = document.createElement('a');
        // a.href = checkoutUrl;
        // a.target = '_blank';
        // a.rel = 'noopener noreferrer';
        // document.body.appendChild(a);
        // a.click();
        // document.body.removeChild(a);
        sessionStorage.setItem('b2b-reset-on-back', '1');
        window.location.href = checkoutUrl;
        return;
      }

      throw new Error('Draft order failed');
    } catch (error) {
      _b2bCheckoutLog.warn('Error:', error);
      alert('There was an issue validating your B2B checkout.');
      processing = false;
    }
  });

  function getVATandEmailFromForm() {
    const vatNumber = document.getElementById('b2b-vat-number')?.value || 'No VAT';
    const email = document.getElementById('b2b-business-email')?.value || 'No Email';
    return {
      email: email,
      vat: vatNumber
    };
  }

  async function addIossCartAttributes() {
    const countryCode = window.getSelectedMarketCountry() || window.Shopify?.country || 'GB';
    const isEU = typeof window.is_EuCountry === 'function' && window.is_EuCountry(countryCode);

    if (isEU && !isB2BCustomerForCheckout) {
      const cartTotalEuroVatExcl = typeof window.cartTotalEuroVatExcl === 'number' ? window.cartTotalEuroVatExcl : null;

      if (cartTotalEuroVatExcl === null) {
        _b2bCheckoutLog.warn('cartTotalEuroVatExcl not available on window, skipping IOSS attributes');
      } else {
        const iossEligible = cartTotalEuroVatExcl <= 150;
        _b2bCheckoutLog.log('IOSS: cart total excl. VAT (EUR):', cartTotalEuroVatExcl, '| ioss_eligible:', iossEligible);

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              ioss_eligible: String(iossEligible),
              cart_total_euro_vat_excl: cartTotalEuroVatExcl.toFixed(2)
            }
          })
        });

        if (!response.ok) {
          throw new Error(`Cart attributes update failed with status ${response.status}`);
        }

        _b2bCheckoutLog.log('IOSS cart attributes set successfully');
      }
    } else {
      _b2bCheckoutLog.log('IOSS attributes skipped — not EU market or B2B customer');
    }
  }

  async function continueDefaultCheckout(event) {
    if (!isB2BCustomerForCheckout) {
      const countryCode = window.getSelectedMarketCountry() || window.Shopify?.country || 'GB';
      if (window.is_EuCountry(countryCode)) {
        _b2bCheckoutLog.log('EU non-B2B → adding IOSS cart attributes before checkout');
        try {
          await addIossCartAttributes();
        } catch (err) {
          _b2bCheckoutLog.warn('Failed to add IOSS cart attributes, proceeding anyway:', err);
        }
      }
    }

    processing = false;

    if (event.submitter && event.submitter.name) {
      const submitterInput = document.createElement('input');
      submitterInput.type = 'hidden';
      submitterInput.name = event.submitter.name;
      submitterInput.value = event.submitter.value || 'Checkout';
      cartForm.appendChild(submitterInput);
    } else {
      const checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'Checkout';
      cartForm.appendChild(checkoutInput);
    }

    HTMLFormElement.prototype.submit.call(cartForm);
  }
});
